const streams = [
  'Electronics and Communication Engineering',
  'Computer Science',
  'Information Technology',
  'Mechanical Engineering',
  'Mechatronics Engineering',
  'Civil Engineering',
  'Electrical Engineering',
  'Environmental Engineering',
  'Aerospace and Aeronautics Engineering',
  'Bachelors of Computer Applications',
  'Masters of Computer Applications',
  'Bachelors of Science',
  'Masters of Science',
  'Bacelors of Business Administration',
  'Masteres of Business Administration',
];

export default streams;



// WEBPACK FOOTER //
// ./src/utils/streams.js